<template>
  <a-modal v-model="visible" title="新增共享客户" @ok="handleOk" @cancel="handleClose" :confirmLoading="confirmLoading"
    :maskClosable="false">
    <a-form-model ref="ruleForm" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-form-model-item label="已选客户" required>
        <a-tag v-for="v in customerShareList" :key="v.customer_id">{{
          v.customer_name
          }}</a-tag>
      </a-form-model-item>
      <a-form-model-item label="共享员工">
        <a-select v-model="form.user_ids" mode="multiple" style="width: 100%" placeholder="请选择共享员工"
          option-label-prop="label" :filter-option="filterOption">
          <a-select-option v-for="v in userList" :key="v.user_id" :value="v.user_id" :label="v.real_name"
            :disabled="false">
            {{ v.real_name }}
            <span role="img" :aria-label="v.real_name" style="font-size: 14px; color: #888">
              ({{ v.department.department_name }})
            </span>
          </a-select-option>
        </a-select>
      </a-form-model-item>
    </a-form-model>
    <a-alert v-if="form.customer_ids.length > 1" :message="`当前多选了${form.customer_ids.length}个客户，共享成功后, 将覆盖之前的已经共享同事`" class="mb-10"></a-alert>
    <a-alert :message="`如不选择共享员工，将清除之前共享的所有同事`"></a-alert>
  </a-modal>
</template>
<script>
import { mapState } from 'vuex';
export default {
  data() {
    return {
      visible: false,
      confirmLoading: false,
      customerShareList: [],
      form: {
        customer_ids: [],
        user_ids: [],
      },
      rules: {},
      userList: [],
      labelCol: { span: 6 },
      wrapperCol: { span: 18 },
    };
  },
  computed: {
    ...mapState(['userinfo']),
    whoManagerId() {
      return this.customerShareList[0].managerinfo.user_id;
    },
    whoishad() {
      return this.customerShareList.filter(v => v.manager_share == 1).map(v => v.customer_name)
    }
  },
  methods: {
    init(selectedRow) {
      this.customerShareList = selectedRow;
      this.form.customer_ids = selectedRow.map((v) => v.customer_id);
      this.visible = true;
      this.getUserList();
      this.getCustomerInfo();
    },
    getCustomerInfo() {
      console.log(this.form.customer_ids)
      if (this.form.customer_ids.length == 1) {
        const id = this.form.customer_ids[0];
        this.$http({
          url: "/admin/customer/info",
          method: "post",
          data: {
            id
          }
        }).then((res) => {
          console.log(res)
          this.form.user_ids = res.data.managerChildren.map(v => v.user_id);
        });
      }
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    getUserList() {
      this.$http({
        url: "/admin/user/page?page=1&limit=200",
        method: "get",
      }).then((res) => {
        this.userList = res.data.result;
      });
    },
    handleOk() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.confirmLoading = true;
          this.$http({
            url: "/admin/customer/addcustomershare",
            method: "post",
            data: this.form,
          })
            .then(() => {
              this.$message.success("共享操作成功");
              this.handleClose();
              this.$emit("ok");
            })
            .finally(() => (this.confirmLoading = false));
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    handleClose() {
      this.$refs.ruleForm.resetFields();
      this.visible = false;
      this.form.user_ids = [];
    },
  },
};
</script>

<style></style>